var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 8.65039H13.5999",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3999 11.7998H11.3499",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.20404C13.1762 1.43827 11.6393 1 10 1C5.02943 1 1 5.02943 1 10C1 11.4397 1.33806 12.8004 1.93911 14.0072C2.09885 14.3279 2.15201 14.6945 2.05941 15.0405L1.52336 17.044C1.29066 17.9137 2.08631 18.7093 2.95601 18.4767L4.95945 17.9406C5.30554 17.848 5.67209 17.9012 5.99278 18.0608C7.19953 18.662 8.56027 19 10 19C14.9705 19 19 14.9705 19 10C19 8.36074 18.5617 6.82378 17.796 5.5",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.49edd2237e7cbbcc875617d521b5bbdf.svg";
export { ForwardRef as ReactComponent };